/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCheckoutSessionDto
 */
export interface CreateCheckoutSessionDto {
    /**
     * Subscription plan selection
     * @type {string}
     * @memberof CreateCheckoutSessionDto
     */
    subscriptionPlan: CreateCheckoutSessionDtoSubscriptionPlanEnum;
}


/**
 * @export
 */
export const CreateCheckoutSessionDtoSubscriptionPlanEnum = {
    Monthly: 'monthly',
    SixMonths: 'six_months'
} as const;
export type CreateCheckoutSessionDtoSubscriptionPlanEnum = typeof CreateCheckoutSessionDtoSubscriptionPlanEnum[keyof typeof CreateCheckoutSessionDtoSubscriptionPlanEnum];


/**
 * Check if a given object implements the CreateCheckoutSessionDto interface.
 */
export function instanceOfCreateCheckoutSessionDto(value: object): value is CreateCheckoutSessionDto {
    if (!('subscriptionPlan' in value) || value['subscriptionPlan'] === undefined) return false;
    return true;
}

export function CreateCheckoutSessionDtoFromJSON(json: any): CreateCheckoutSessionDto {
    return CreateCheckoutSessionDtoFromJSONTyped(json, false);
}

export function CreateCheckoutSessionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutSessionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionPlan': json['subscriptionPlan'],
    };
}

export function CreateCheckoutSessionDtoToJSON(json: any): CreateCheckoutSessionDto {
    return CreateCheckoutSessionDtoToJSONTyped(json, false);
}

export function CreateCheckoutSessionDtoToJSONTyped(value?: CreateCheckoutSessionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionPlan': value['subscriptionPlan'],
    };
}

